export default "__VITE_ASSET__61eaabb9__"